import React from 'react';
import PropTypes from 'prop-types';

const ProductHeroSection = ({
  backgroundImage,
  contentImage,
  title,
  description,
  buttons = [],
  overlayOpacity = 0.85,
  imagePosition = 'right', // 'left' or 'right'
  contentPadding = 'px-12 md:px-20 lg:px-28',
}) => {
  return (
    <section className="relative py-12 md:py-16 lg:py-20 overflow-hidden mt-16">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src={backgroundImage}
          alt="Background"
          className="w-full h-full object-cover"
        />
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black/50"></div>
        {/* Blue Overlay with custom opacity */}
        <div 
          className="absolute inset-0 primary-bg" 
          style={{ opacity: overlayOpacity }}
        ></div>
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className={`grid grid-cols-1 lg:grid-cols-2 gap-8 items-center ${
          imagePosition === 'left' ? 'lg:grid-flow-dense' : ''
        }`}>
          {/* Content Side */}
          <div className={`${contentPadding} py-8 lg:py-0 ${
            imagePosition === 'left' ? 'lg:col-start-2' : ''
          }`}>
            <h1 className="  font-bold text-white mb-4 md:mb-5 lg:mb-6 leading-tight">
              {title}
            </h1>
            
            <p className="   text-white opacity-90 mb-6 md:mb-8 leading-relaxed">
              {description}
            </p>

            {/* CTA Buttons */}
            {buttons.length > 0 && (
              <div className="flex flex-col sm:flex-row gap-4">
                {buttons.map((button, index) => (
                  <button
                    key={index}
                    onClick={button.onClick}
                    className={`${button.className || 'btn-secondary'}   font-semibold px-4 md:px-6 py-2 md:py-2.5 w-full sm:w-auto ${
                      button.customClass || ''
                    }`}
                    style={button.style}
                  >
                    {button.icon && <span className="mr-2">{button.icon}</span>}
                    {button.label}
                  </button>
                ))}
              </div>
            )}
          </div>

          {/* Image Side */}
          <div className={`relative ${
            imagePosition === 'left' ? 'lg:col-start-1' : ''
          }`}>
            <div className="relative min-h-[300px] lg:min-h-[400px] flex items-center justify-center">
              <img
                src={contentImage}
                alt={title}
                className={`w-full h-auto max-h-[400px] lg:max-h-[500px] object-contain ${
                  imagePosition === 'right' ? 'rounded-l-xl' : 'rounded-r-xl'
                }`}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

ProductHeroSection.propTypes = {
  backgroundImage: PropTypes.string.isRequired,
  contentImage: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func,
      className: PropTypes.string,
      customClass: PropTypes.string,
      icon: PropTypes.node,
      style: PropTypes.object,
    })
  ),
  overlayOpacity: PropTypes.number,
  imagePosition: PropTypes.oneOf(['left', 'right']),
  contentPadding: PropTypes.string,
};

export default ProductHeroSection;